<template>
  <client-only>
    <div class="details-container">
      <div class="px-2 py-4 detail-row">
        <div class="px-0 py-0 icon">
          <v-icon class="icon-user primary--text"></v-icon>
        </div>
        <div class="px-0 py-0">
          <h5 class="font-weight-medium">{{ numOfEmployees }}</h5>
          <h6 class="body-2">עובדים</h6>
        </div>
      </div>
      <div class="px-2 py-4 detail-row">
        <div class="px-0 py-0 icon">
          <v-icon class="icon-suitcase primary--text"></v-icon>
        </div>
        <div class="px-0 py-0">
          <h5 class="font-weight-medium">{{ industry }}</h5>
          <h6 class="body-2">סקטור</h6>
        </div>
      </div>
      <!-- <div class="px-2 py-4 detail-row" v-if="numOfBranches">
        <div class="px-0 py-0 icon">
          <v-icon class="icon-forma-1-4 primary--text"></v-icon>
        </div>
        <div class="px-0 py-0">
          <h5 class="font-weight-medium">{{ numOfBranches }}</h5>
          <h6 class="body-2">סניפים</h6>
        </div>
      </div> -->
    </div>
  </client-only>
</template>

<script>
export default {
  props: {
    isMobile: {
      type: Boolean
    },
    numOfEmployees: {
      type: String
    },

    industry: {
      type: String
    },

    numOfBranches: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.details-container {
  display: flex;
  justify-content: space-evenly;
  max-width: 700px;
  margin: auto;
  .detail-row {
    display: flex;
    align-items: center;
    color: white;
    .v-icon.v-icon {
      font-size: 45px;
      margin-left: 10px;
    }
    h5 {
      font-size: 24px;
    }
    h6 {
      font-size: 14px;
    }
  }
}
.v-icon:hover {
  color: $primary !important;
}
.icon-forma-1-4:before {
  font-size: 35px;
}
.company-detail-items.industry {
  border-right: 5px solid #fff;
}
@media screen and (min-width: 600px) {
  .company-detail {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .details-container {
    .detail-row {
      .v-icon.v-icon {
        font-size: 35px;
      }
      .icon-forma-1-4:before {
        font-size: 25px;
      }
      h5 {
        font-size: 14px;
      }
      h6 {
        font-size: 8px;
      }
    }
  }
}
</style>
